import React from "react";
interface IconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}
const DeezerIcon: React.FC<IconProps> = (props) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 40 40" fill="none" {...props}>
      <path d="M37 14h-7.568v4.428H37V14z" fill="#40AB5D" />
      <path
        d="M37 20.14h-7.568v4.427H37v-4.428z"
        fill="url(#prefix__paint0_linear_2218_5666)"
      />
      <path
        d="M37 26.278h-7.568v4.428H37v-4.428z"
        fill="url(#prefix__paint1_linear_2218_5666)"
      />
      <path
        d="M9.568 32.417H2v4.428h7.568v-4.428z"
        fill="url(#prefix__paint2_linear_2218_5666)"
      />
      <path
        d="M18.706 32.417h-7.568v4.428h7.568v-4.428z"
        fill="url(#prefix__paint3_linear_2218_5666)"
      />
      <path
        d="M27.862 32.417h-7.568v4.428h7.568v-4.428z"
        fill="url(#prefix__paint4_linear_2218_5666)"
      />
      <path
        d="M37 32.417h-7.568v4.428H37v-4.428z"
        fill="url(#prefix__paint5_linear_2218_5666)"
      />
      <path
        d="M27.862 26.278h-7.568v4.428h7.568v-4.428z"
        fill="url(#prefix__paint6_linear_2218_5666)"
      />
      <path
        d="M18.706 26.278h-7.568v4.428h7.568v-4.428z"
        fill="url(#prefix__paint7_linear_2218_5666)"
      />
      <path
        d="M18.706 20.14h-7.568v4.427h7.568v-4.428z"
        fill="url(#prefix__paint8_linear_2218_5666)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 9A7 7 0 112 9a7 7 0 0114 0zM5.3 8.912c0-.69.56-1.25 1.25-1.25h1.163V6.55a1.25 1.25 0 112.5 0v1.112h1.15a1.25 1.25 0 010 2.5h-1.15v1.2a1.25 1.25 0 01-2.5 0v-1.2H6.55c-.69 0-1.25-.56-1.25-1.25z"
        fill="#fff"
      />
      <defs>
        <linearGradient
          id="prefix__paint0_linear_2218_5666"
          x1={33.253}
          y1={24.605}
          x2={33.182}
          y2={20.074}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#358C7B" />
          <stop offset={0.526} stopColor="#33A65E" />
        </linearGradient>
        <linearGradient
          id="prefix__paint1_linear_2218_5666"
          x1={29.321}
          y1={30.479}
          x2={37.115}
          y2={26.507}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#222B90" />
          <stop offset={1} stopColor="#367B99" />
        </linearGradient>
        <linearGradient
          id="prefix__paint2_linear_2218_5666"
          x1={2.001}
          y1={34.633}
          x2={9.563}
          y2={34.633}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F90" />
          <stop offset={1} stopColor="#FF8000" />
        </linearGradient>
        <linearGradient
          id="prefix__paint3_linear_2218_5666"
          x1={11.147}
          y1={34.633}
          x2={18.708}
          y2={34.633}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF8000" />
          <stop offset={1} stopColor="#CC1953" />
        </linearGradient>
        <linearGradient
          id="prefix__paint4_linear_2218_5666"
          x1={20.291}
          y1={34.633}
          x2={27.853}
          y2={34.633}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CC1953" />
          <stop offset={1} stopColor="#241284" />
        </linearGradient>
        <linearGradient
          id="prefix__paint5_linear_2218_5666"
          x1={29.428}
          y1={34.633}
          x2={36.99}
          y2={34.633}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#222B90" />
          <stop offset={1} stopColor="#3559A6" />
        </linearGradient>
        <linearGradient
          id="prefix__paint6_linear_2218_5666"
          x1={19.993}
          y1={29.686}
          x2={28.152}
          y2={27.3}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CC1953" />
          <stop offset={1} stopColor="#241284" />
        </linearGradient>
        <linearGradient
          id="prefix__paint7_linear_2218_5666"
          x1={10.877}
          y1={27.019}
          x2={18.977}
          y2={29.967}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.003} stopColor="#FC0" />
          <stop offset={1} stopColor="#CE1938" />
        </linearGradient>
        <linearGradient
          id="prefix__paint8_linear_2218_5666"
          x1={11.782}
          y1={19.451}
          x2={18.073}
          y2={25.256}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.003} stopColor="#FFD100" />
          <stop offset={1} stopColor="#FD5A22" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const MemoDeezerIcon = React.memo(DeezerIcon);
export default MemoDeezerIcon;
